export function ajax(o, limitTime) {
    if (o.lock) {
        if ($(o.lock).data('lock')) {
            return;
        }

        $(o.lock).data('lock', 1);
    }

    var defaultParameter = {
        type: o.type ? o.type : 'GET',
        url: o.url,
        data: o.data ? o.data : '',
        async: o.async == false ? o.async : true,
        timeout: limitTime || 120000,
        success: function (res) {
            $(o.lock).data('lock', 0);
            if (o.log == 'print') {
                console.log('---------------------------------------------');
                console.log(res);
                console.log('---------------------------------------------');
            }

            var data = typeof res == 'object' ? res : $.parseJSON(res);

            o.callback && o.callback(data);

            if (o.lock) {
                setTimeout(()=>{
                    $(o.lock).data('lock', 0);
                },1000)
            }
        },
        error: function (errMsg) {
            if (o.log == 'print') {
                console.log('---------------------------------------------');
                console.log(errMsg);
                console.log('---------------------------------------------');
            }
            var tipsTxt = '系统错误!',
                online = window.navigator.onLine;

            if (errMsg.statusText == 'timeout') {
                tipsTxt = '请求超时!';
            }

            if (!online) {
                tipsTxt = '哎呀，网络好像有问题，请检查网络连接！';
            }
            if (errMsg.statusText !== "abort") {
                layer.msg(tipsTxt);
            }


            if (o.lock) {
                $(o.lock).data('lock', 0);
            }

            o.callback && o.callback(tipsTxt, errMsg);
        }
    };


    $.each(o, function (name, value) {
        if (name != 'url' & name != 'type' & name != 'data' & name != 'callback' & name != 'success' & name != 'error' & name != 'async') {
            var obj = {};

            obj[name] = value;
            $.extend(true, defaultParameter, obj)
        }
    });

    return $.ajax(defaultParameter);
}
// promise版本
export function ajaxPromise(o, limitTime) {
    return new Promise((resolve, reject) => {
        o = Object.assign(o, {
            callback({code, data, error=[], msg}) {
                if (typeof code == "undefined" || code) {
                    var href = $('._loginBtn').attr('href');
                    // layer.closeAll();
                    layer.msg(error[0] && error[0].value || msg || "未知错误");
                    if (href && code == 301) {
                        setTimeout(function () {
                            window.location.href = href;
                        }, 500)
                    }
                    // if(code == "100070019" || code ==  ){
                    //   reject(data);
                    // }else{
                    if(data ){
                        data.code = code
                        data.msg = msg
                        reject(data);
                    }
                    // }

                    
                    return false;
                }
                resolve(data);
            },
            errorCallback() {
                // layer.closeAll();
                layer.msg("网络异常，请稍后再试!");
                reject();
            }
        })
        ajax(o, limitTime);
    })
}
